import React, { useEffect, useRef } from 'react';

const MagneticHover = ({ children, className = '', intensity = 0.3 }) => {
  const elementRef = useRef(null);

  useEffect(() => {
    const element = elementRef.current;
    if (!element) return;

    const handleMouseMove = (e) => {
      const rect = element.getBoundingClientRect();
      const centerX = rect.left + rect.width / 2;
      const centerY = rect.top + rect.height / 2;
      
      const deltaX = (e.clientX - centerX) * intensity;
      const deltaY = (e.clientY - centerY) * intensity;
      
      element.style.setProperty('--mouse-offset-x', `${deltaX}px`);
      element.style.setProperty('--mouse-offset-y', `${deltaY}px`);
      
      // For radial gradient effects
      const mouseX = ((e.clientX - rect.left) / rect.width) * 100;
      const mouseY = ((e.clientY - rect.top) / rect.height) * 100;
      element.style.setProperty('--mouse-x', `${mouseX}%`);
      element.style.setProperty('--mouse-y', `${mouseY}%`);
    };

    const handleMouseLeave = () => {
      element.style.setProperty('--mouse-offset-x', '0px');
      element.style.setProperty('--mouse-offset-y', '0px');
      element.style.setProperty('--mouse-x', '50%');
      element.style.setProperty('--mouse-y', '50%');
    };

    element.addEventListener('mousemove', handleMouseMove);
    element.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      element.removeEventListener('mousemove', handleMouseMove);
      element.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [intensity]);

  return React.cloneElement(children, {
    ref: elementRef,
    className: `${children.props.className || ''} ${className}`.trim()
  });
};

export default MagneticHover;